import { dropCursor } from '@tiptap/pm/dropcursor';

import { createRicosFunctionalExtension } from './create-ricos-extension';
import styles from './statics/styles-scss';

export const dropcursor = createRicosFunctionalExtension<{
  /**
    The color of the cursor. Defaults to `black`. Use `false` to apply no color and rely only on class.
    */
  color?: string | false;
  /**
    The precise width of the cursor in pixels. Defaults to 1.
    */
  width?: number;
  /**
    A CSS class name to add to the cursor element.
    */
  class?: string;
}>({
  name: 'dropCursor',
  groups: [],
  type: 'extension',

  createExtensionConfig() {
    return {
      name: this.name,
      addOptions() {
        return {
          color: '#116DFF',
          width: 2,
          class: styles.dropcursor,
        };
      },

      addProseMirrorPlugins() {
        return [dropCursor(this.options)];
      },
    };
  },
});
